import { Attrs, MinzeElement } from 'minze'

export interface LvcCalendarIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcCalendarIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 24],
    ['data-height', 24],
  ]

  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.00221 10.8281C2.99629 12.6704 3.00098 13.0281 3.03217 14.0331C3.07312 15.3526 3.06759 17.7539 3.05242 19.6503C3.0441 20.6888 3.90809 21.5251 4.94836 21.4994C9.49566 21.3871 14.7374 21.4975 16.0654 21.3497C16.8993 21.2569 18.0855 21.2578 19.1223 21.282C20.185 21.3068 21.0477 20.4386 20.998 19.3789C20.8808 16.8838 20.7638 13.5712 20.8456 12.1065C20.8919 11.2791 20.9064 11.6707 20.9043 10.5411M3.00221 10.8281C3.00543 9.82423 3.01181 8.17878 3.01876 6.8897C3.02367 5.97938 3.71169 5.23799 4.62366 5.2215C5.2568 5.21005 5.95178 5.20865 6.55867 5.20995M3.00221 10.8281C4.51894 10.6709 7.8974 10.5068 9.3014 10.5411C11.0564 10.5839 14.2884 10.8499 15.7149 10.8136C16.8561 10.7845 19.65 10.6198 20.9043 10.5411M20.9043 10.5411C20.9027 9.64519 20.8907 8.18775 20.8759 6.98963C20.8637 6.00225 20.0511 5.21135 19.0617 5.20723C18.5653 5.20516 18.056 5.20443 17.6247 5.20994M6.55867 5.20995V6.15333C6.55867 6.41889 6.77437 6.63418 7.04045 6.63418C7.30654 6.63418 7.52224 6.4189 7.52224 6.15333V5.20995M6.55867 5.20995V3.98085C6.55867 3.71528 6.77437 3.5 7.04045 3.5C7.30654 3.5 7.52224 3.71528 7.52224 3.98085V5.20995M7.52224 5.20995C9.28314 5.23999 11.52 5.29671 12.6608 5.29671C13.5469 5.29671 15.2744 5.31275 16.7104 5.29671M16.7104 5.29671V6.20621C16.7104 6.45819 16.9151 6.66245 17.1676 6.66245C17.42 6.66245 17.6247 6.45819 17.6247 6.20621V5.20994M16.7104 5.29671V3.98451C16.7104 3.73254 16.9151 3.52828 17.1676 3.52828C17.42 3.52828 17.6247 3.73254 17.6247 3.98452V5.20994" stroke="#1E007D" stroke-width="2" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
